import Panel from '@admin/components/panel'
import TeamToken from '@admin/tokens/team'
import React from 'react'
import New from './new'

const mapPropsToPanel = (props, context) => ({
  title: 't(Signups)',
  collection: {
    endpoint: '/api/admin/truevail/admin/signups',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Team)', key: 'team.title', sort: 'team', primary: true, format: (advisor) => <TeamToken { ...advisor.team } /> },
      { label: 't(Entity)', key: 'team.entity.type', sort: 'entity' },
      { label: 't(Signup Page)', key: 'signup_page.title', sort: 'signup_page' },
      { label: 't(Referred By)', key: 'data.referred_by', sort: 'referred_by', collapsing: true },
      { label: 't(Signed Up)', key: 'completed_at', collapsing: true,  format: 'datetime' }
    ],
    defaultSort: { key: 'completed_at', order: 'desc' },
    empty: {
      svg: 'square_check',
      title: 't(No Signups)',
      text: 't(No one has signed up yet)',
      buttons: [
        {
          label: 't(Create Signup)',
          modal: New
        }
      ]
    },
    entity: 'signup',
    onClick: (record) => {
      const { entity } = record.team
      if(entity.type === 'advisor') context.router.push(`/admin/truevail/admin/advisors/${entity.advisor_id}/signup`)
      if(entity.type === 'agency') context.router.push(`/admin/truevail/admin/agencies/${entity.agency_id}/signup`)
      if(entity.type === 'supplier') context.router.push(`/admin/truevail/admin/suppliers/${entity.supplier_id}/signup`)
    }
  },
  task: {
    svg: 'plus',
    tooltip: 't(Create Signup)',
    modal: New
  }
})

export default Panel(null, mapPropsToPanel)
